module.exports = __webpack_public_path__ + "img/diagnose-logo.56845a7f.png";